export var CallProcessorEditor = function(){

  return {
    update_row_after_edit_callback: null,
    update_row_after_invite_callback: null,
    
    init: function(update_row_after_edit_callback, update_row_after_invite_callback){
      CallProcessing.update_row_after_edit_callback = update_row_after_edit_callback;
      CallProcessing.update_row_after_invite_callback = update_row_after_invite_callback;
      initialize();
    },
    handle_edit_link_click: function(e) {
      handle_edit_link_click2(e);
    },
    get_processor_settings: function(user_id, group_id, callback){
      _get_processor_settings(user_id, group_id, callback)
    }
  }


function initialize() {
  $('#invite_modal').click( function(e) {
    e.preventDefault();
    $('.modal-title').text('Invite Call Processing User');
    $('#invite_user').show();
    $('#save_user').hide();
    $('#usage_mode').val('invite');
    $('#invited_email').val( '' );
    $('#invited_role').val( '' );
    $('user_id').val('');
    $("#invite_user_modal").modal('show');
  })

  $('#invite_user_modal').on('hide.bs.modal', function () {
    $('#ecp_available_call_types option').remove()
    $('#ecp_selected_call_types option').remove()
    $('#ecp_available_processing_queues option').remove()
    $('#ecp_selected_processing_queues option').remove()
    $('#dcp_available_processing_queues option').remove()
    $('#dcp_selected_processing_queues option').remove()

    $('.edit_call_processing_settings.editing').removeClass('editing');
  })

  // reset modal items when shown
  $('#invite_user_modal').on('show.bs.modal', function () {
    var mode = $('#usage_mode').val();
    if (mode === 'edit') {
      init_edit_modal_settings();
    }
    else {
      $('#invited_role').val('')
      $('#invited_email').trigger('focus')
      hide_modal_templates()
    }
  })


  $('#dcp_available_processing_queues').multiselect({
    right:        '#dcp_selected_processing_queues',
    rightAll:     '#dcp_processing_queues_multiselect_rightAll',
    rightSelected:'#dcp_processing_queues_multiselect_rightSelected',
    leftSelected: '#dcp_processing_queues_multiselect_leftSelected',
    leftAll:      '#dcp_processing_queues_multiselect_leftAll'
  });

  $('#ecp_available_processing_queues').multiselect({
    right:        '#ecp_selected_processing_queues',
    rightAll:     '#ecp_processing_queues_multiselect_rightAll',
    rightSelected:'#ecp_processing_queues_multiselect_rightSelected',
    leftSelected: '#ecp_processing_queues_multiselect_leftSelected',
    leftAll:      '#ecp_processing_queues_multiselect_leftAll',
    afterMoveToRight: update_call_ecp_types,
    afterMoveToLeft: update_call_ecp_types,
  });

  $('#ecp_available_call_types').multiselect({
    right:        '#ecp_selected_call_types',
    rightAll:     '#ecp_call_types_multiselect_rightAll',
    rightSelected:'#ecp_call_types_multiselect_rightSelected',
    leftSelected: '#ecp_call_types_multiselect_leftSelected',
    leftAll:      '#ecp_call_types_multiselect_leftAll'
  });

  $('#ocp_available_processing_queues').multiselect({
    right:        '#ocp_selected_processing_queues',
    rightAll:     '#ocp_processing_queues_multiselect_rightAll',
    rightSelected:'#ocp_processing_queues_multiselect_rightSelected',
    leftSelected: '#ocp_processing_queues_multiselect_leftSelected',
    leftAll:      '#ocp_processing_queues_multiselect_leftAll'
  });

  // someone selected an industry
  $('#invite_user_modal .available_industry_types').on('change', function(e){
    var selected_role = $('#invited_role option:selected').data('name');
    var template_selector = '.call_processor_template#' + selected_role    
    var v = $(template_selector +' .available_industry_types option:selected').val();
    //console.log('selected industry2: ' + v)

    // remove all data from industry selections and call types
    $(template_selector + ' .available_processing_queues option').remove()
    $(template_selector + ' .selected_processing_queues option').remove()
    $(template_selector + ' .available_call_types option').remove()
    $(template_selector + ' .selected_call_types option').remove()
    
    /*
    // add ajax call to get the available industries to show 
    var url = '/admin/call_processing/sub_industries?industry=' + v
    pageLoadingFrame("show");
    $.get(url, function(data){
      //console.log(data)
      var industries_el = $(template_selector +' .available_industries');
      $(template_selector +' .available_industries option').remove();
      var html = '';
      for (var i = 0; i < data.length; i++) {
        var temp = data[i]
        html += `<option value="${temp['id']}">${temp['display_name']}</option>`
      }
      $(industries_el).append(html)
      pageLoadingFrame("hide");
    })
    */
  })


  // logic for when the invite user role changes
  $('#invite_user_modal #invited_role').on('change', function(e){
    var v = $('#invited_role option:selected').data('name');
    if (v !== undefined) {
      hide_modal_templates()

      $('.available_processing_queues option').remove()
      $('.ecp_available_call_types option').remove()
      $('.available_industry_types').val('')

      if (v === 'department_call_processor' ) {
        // populate the industries
        populate_dcp_processing_queues_select_box()
      }
      else if (v === 'enhanced_call_processor' ) {
        populate_ecp_processing_queues_select_box()
      }
      else if (v === 'outbound_call_processor' ) {
      }
      
      // show the appropriate template
      $('#user_options .call_processor_template#' + v).removeClass('hide')
    }
  })

  $('#invite_user_modal button#invite_user').click(function(e){
    e.preventDefault();
    $('#invited_email').removeClass('error');
    var email = $('#invited_email').val().trim();
    var role_id = $('#invited_role').val().trim();
    var id = $('#group_id').val();

    var selected_role = $('#invited_role option:selected').data('name');
    var template_selector = '.call_processor_template#' + selected_role    
    var industry_type_id = $(template_selector +' .available_industry_types option:selected').val();
    var selected_industries_ids = [];
    $(template_selector +' .selected_industries option').each(function(e){
      selected_industries_ids.push( $(this).val() )
    });
    var selected_processing_queues_ids = [];
    $(template_selector +' .selected_processing_queues option').each(function(e){
      selected_processing_queues_ids.push( $(this).val() )
    });


    var selected_call_type_ids = []
    $(template_selector +' .selected_call_types option').each(function(e){
      selected_call_type_ids.push( $(this).val() )
    });

    if (email === '') {
      modal_notify('Please enter a valid email address.', 'danger');
      return;
    }

    if (role_id === '') {
      modal_notify('Please select a role for the user.', 'danger');
      return;
    }

    // validate based on selected user role 
    if (! validate_user_role(selected_role) ) {
      return;
    }

    pageLoadingFrame("show");
    $.ajax({
      type: 'POST',
      url: '/admin/call_processing_groups/invite',
      data: {email: email, group_id: id, role_id: role_id, industry_type: industry_type_id, selected_industries: selected_industries_ids, selected_processing_queues_ids: selected_processing_queues_ids, selected_call_types: selected_call_type_ids, selected_role: selected_role},
      dataType: 'json',
      success: function(result) {
        if (result.success)
        {
          $('#invite_user_modal').modal('hide')
          Common.notify(result.msg, 'success');
          if (CallProcessing.update_row_after_invite_callback) {
            CallProcessing.update_row_after_invite_callback( [result.r1, result.r2, result.r3, make_edit_button(result.group_id, result.user_id)] )
          }
          else {
            console.log('No callback provided to handle updating row data after invite.')
          }

          //users_table.row.add([result.r1, result.r2, result.r3, make_edit_button(result.group_id, result.user_id)]).draw(false);
        }
        else
        {
          modal_notify(result.msg, 'danger');
          $('#invited_email').addClass('error');
        }
        pageLoadingFrame("hide");
      },
    error: function(e){
        pageLoadingFrame("hide");
      }  
    });
  });

  $('#invite_user_modal button#save_user').click(function(e){
    e.preventDefault();
    $('#invited_email').removeClass('error');
    var email = $('#invited_email').val().trim();
    var role_id = $('#invited_role').val().trim();
    var id = $('#group_id').val();
    var user_id = $('#user_id').val();

    var selected_role = $('#invited_role option:selected').data('name');
    var template_selector = '.call_processor_template#' + selected_role    
    var industry_type_id = $(template_selector +' .available_industry_types option:selected').val();
    var selected_industries_ids = [];
    $(template_selector +' .selected_industries option').each(function(e){
      selected_industries_ids.push( $(this).val() )
    });

    var selected_processing_queues_ids = [];
    $(template_selector +' .selected_processing_queues option').each(function(e){
      selected_processing_queues_ids.push( $(this).val() )
    });

    var selected_call_type_ids = []
    $(template_selector +' .selected_call_types option').each(function(e){
      selected_call_type_ids.push( $(this).val() )
    });

    if (email === '') {
      modal_notify('Please enter a valid email address.', 'danger');
      return;
    }

    if (role_id === '') {
      modal_notify('Please select a role for the user.', 'danger');
      return;
    }

    // validate based on selected user role 
    if (! validate_user_role(selected_role) ) {
      return;
    }

    pageLoadingFrame("show");
    $.ajax({
      type: 'POST',
      url: '/admin/call_processing_groups/settings',
      data: {email: email,user_id: user_id,  group_id: id, role_id: role_id, industry_type: industry_type_id, selected_industries: selected_industries_ids, selected_processing_queues_ids: selected_processing_queues_ids, selected_call_types: selected_call_type_ids, selected_role: selected_role},
      dataType: 'json',
      success: function(result) {
        //console.log(result)
        //console.log('update settings:  ' + JSON.stringify(result) )

        if (CallProcessing.update_row_after_edit_callback) {
          CallProcessing.update_row_after_edit_callback(result)
        }
        else {
          console.log('No callback provided to handle updating row data after edit.')
        }

        pageLoadingFrame("hide");
        $("#invite_user_modal").modal('hide');
      },
      error: function(e){
        pageLoadingFrame("hide");
      }
    });
  });

}

function make_edit_button(group_id, user_id ) {
  return `<a onclick='CallProcessorEditor.handle_edit_link_click(this)' href='javascript:;' class="edit_call_processing_settings" data_user_id="${user_id}" data_group_id="${group_id}">Edit</a>`
}

function handle_edit_link_click2(e) {
  var user_id = $(e).attr('data_user_id')
  var group_id = $(e).attr('data_group_id')
  $(e).addClass('editing')

  /*
  pageLoadingFrame("show");
  var url = '/admin/call_processing_groups/settings?user_id=' + user_id + '&group_id=' + group_id
  $.get(url, function(data){
    console.log(data)
    pageLoadingFrame("hide");
    show_edit_modal(data);
  })
  */
  _get_processor_settings(user_id, group_id, function(data){
    show_edit_modal(data);
  })
}

function _get_processor_settings(user_id, group_id, callback) {
  pageLoadingFrame("show");
  var url = '/admin/call_processing_groups/settings?user_id=' + user_id + '&group_id=' + group_id
  $.get(url, function(data){
    console.log(data)
    pageLoadingFrame("hide");
    callback(data);
  })
}

function show_edit_modal(settings) {
  $('.modal-title').text('Edit Call Processing User');
  $('#invite_user').hide();
  $('#save_user').show();
  $('#usage_mode').val('edit');
  $('#user_settings').val( JSON.stringify(settings) );
  $('#user_id').val( settings.meta.user_id);  
  $('#group_id').val( settings.meta.group_id);  
  $('#invited_email').val( settings.meta.email );

  // remove any already selected options 
  $('.selected_industries option').remove();
  $('.selected_call_types option').remove();
  
  $("#invite_user_modal").modal('show');
}


function update_call_ecp_types() {
  var selected_industries_options = $('#ecp_selected_processing_queues option')
  var industry_names = []
  $('#ecp_selected_processing_queues option').each(function(e){
    var selected_industry_name = $(this).val()
    industry_names.push( selected_industry_name )
  })
  
  if (selected_industries_options.length === 0) {
    // if there are no longer any selected industries
    // delete all options from the call types select boxes
    $('#ecp_available_call_types option').remove()
    $('#ecp_selected_call_types option').remove()
  }
  else {
    var selected_industries = []
    
    // get call types for selected industries
    var url = '/admin/call_processing/call_types'
    pageLoadingFrame("show");
    $.post(url, {'processing_queues': industry_names, 'prospectCallTypes': 1}, function(data){
      //console.log(JSON.stringify(data) )

      // get list of selected industry names
      $('#ecp_selected_processing_queues option').each(function(){
        var industry = $(this).text()
        selected_industries.push( industry)
      })

      // get list of selected call types, we do not want to duplicate them
      var selected_call_types = []
      var selected_call_types_name = []
      $('#ecp_selected_call_types option').each(function(){
        var call_type = $(this).val()
        selected_call_types.push( parseInt(call_type) )
        var call_type_name = $(this).text()
        selected_call_types_name.push( call_type_name )
      })

      //console.log('selected_call_types: ' + selected_call_types)

      $('#ecp_available_call_types option').remove();
      var html = '';
      for (var i = 0; i < data.length; i++) {
        // don't add if the item is already selected
        var x = data[i]
        if ( selected_call_types.indexOf(x['id']) === -1) {
          html += `<option value="${x['call_type_id']}">${x['item_name']}</option>`
        }
      }
      $('#ecp_available_call_types').append(html)




      // for each selected call type, iterate thru each
      // selected industry and see if the call type name starts
      // with a selected industry. If not, remove it from the list.
      $('#ecp_selected_call_types option').each(function(){
        var selected_call_type = $(this).text()

        var found_match = false
        for (var z=0; z < selected_industries.length; z++) {
          var selected_industry_name = selected_industries[z]

          // if the selected call type begins with the name of a selected industry
          // we do not want to delete it. 
          if (selected_call_type.indexOf( selected_industry_name ) === 0) {
            found_match = true
            break
          }
        }// for

        if (! found_match) {
          $(this).remove()
        }
      })



      pageLoadingFrame("hide");
    })
    
  }
}
function unpopulate_ecp_industries_select_box() {

}

function generate_processing_queues_select_options() {
  let a=$('#list_of_processing_queues').val()
  let industry_json = JSON.parse(a)
  var html = ''
  for (var i=0; i < industry_json.length; i++) {
    var temp = industry_json[i]
    html += `<option value="${temp['processing_queue_type_id']}">${temp['name']}</option>`
  }
 
  return html
}

function populate_dcp_processing_queues_select_box() {
  const html = generate_processing_queues_select_options()
  $('#dcp_available_processing_queues').append(html)
}

function populate_ecp_processing_queues_select_box() {
  const html = generate_processing_queues_select_options()
  $('#ecp_available_processing_queues').append(html)
}


function hide_modal_templates() {
  // hide templates
  $('#user_options .call_processor_template').each( function(index, e){
    $(this).addClass('hide')
  });
}


// Once the modal is shown, this is called 
// so we use it to setup the ui with the user's save data
function init_edit_modal_settings() {
  var settings = $('#user_settings').val();
  settings = JSON.parse(settings);
  hide_modal_templates();
  $('#invited_role').val( settings.meta.group_role_id );
  $('#invited_role').trigger('change'); // causes the proper ui elements to be shown.

  let selected_role = $('#invited_role option:selected').data('name');
  if (selected_role === 'call_processor_manager') {
    // nothing else to setup for this role
  }
  else if (selected_role === 'department_call_processor') {
    // select saved industries
    if (settings.industries && settings.industries.length > 0) {
      var option_elements = $('#dcp_available_industries option');
      for (var i = 0; i < option_elements.length; i++ ) {
        var temp_el = option_elements[i];
        var temp_el_id = temp_el.getAttribute('value');
        // If the option value is found in the saved settings, make the option selected
        if (Common.objectArrayIndexOf(settings.industries, 'id', parseInt(temp_el_id)) !== -1) {
          temp_el.setAttribute('selected', 'selected');
        }
      } // for
      $('#dcp_industries_multiselect_rightSelected').click();
    }
  }
  else if (selected_role === 'enhanced_call_processor') {
    if (settings.processing_queues && settings.processing_queues.length > 0) {
      var option_elements = $('#ecp_available_processing_queues option');
      for (var i = 0; i < option_elements.length; i++ ) {
        var temp_el = option_elements[i];
        var temp_el_id = temp_el.getAttribute('value');
        // If the option value is found in the saved settings, make the option selected
        if (Common.objectArrayIndexOf(settings.processing_queues, 'id', parseInt(temp_el_id)) !== -1) {
          temp_el.setAttribute('selected', 'selected');
        }
      } // for
      $('#ecp_processing_queues_multiselect_rightSelected').click();


      // wait for the ajax request to complete 

      Common.waitFor(
        function(){
          // This is the condition we are waiting for to be true.
          // When the ajax request is complete, this will populate.
          return $('#ecp_available_call_types option').length > 0;
        },
        function() {
          // Now select any selected call_types
          if (settings.call_types && settings.call_types.length > 0) {
            var option_elements = $('#ecp_available_call_types option');
            for (var i = 0; i < option_elements.length; i++ ) {
              var temp_el = option_elements[i];
              var temp_el_id = temp_el.getAttribute('value');
              // If the option value is found in the saved settings, make the option selected
              if (Common.objectArrayIndexOf(settings.call_types, 'id', parseInt(temp_el_id)) !== -1) {
                temp_el.setAttribute('selected', 'selected');
              }
            } // for
            $('#ecp_call_types_multiselect_rightSelected').click();
          }
        },
        function(){
          //console.log('waitFor industries TIMEOUT EXITING');
        },
        3000
      ); // Wait for 3S for the resources to load
    } // if
  }
  else if (selected_role === 'outbound_call_processor') {
    if (settings.industry_type) {
      $('#ocp_available_industry_types').val( parseInt(settings.industry_type.id) );
      $('#ocp_available_industry_types').trigger('change');
      // wait a few moments for the ajax request to complete 
      
      Common.waitFor(
        function(){
          // This is the condition we are waiting for to be true.
          // When the ajax request is complete, this will populate.
          return $('#ocp_available_industries option').length > 0;
        },
        function() {
          // Now select any selected industries
          if (settings.industries && settings.industries.length > 0) {
            var option_elements = $('#ocp_available_industries option');
            for (var i = 0; i < option_elements.length; i++ ) {
              var temp_el = option_elements[i];
              var temp_el_id = temp_el.getAttribute('value');
              // If the option value is found in the saved settings, make the option selected
              if (Common.objectArrayIndexOf(settings.industries, 'id', parseInt(temp_el_id)) !== -1) {
                temp_el.setAttribute('selected', 'selected');
              }
            } // for
            $('#ocp_industries_multiselect_rightSelected').click();
          }
        },
        function(){
          //console.log('waitFor industries TIMEOUT EXITING');
        },
        3000
      ); // Wait for 3S for the resources to load
    }
  }
}


function modal_notify(msg, status) {
    Common.notify(msg, status, '#invite_user_modal .modal-body');
}

function validate_user_role(role) {
  var is_valid = true;

  if (role === 'call_processor_manager') {
    // nothing else to validate yet for this role
  }
  else if (role === 'department_call_processor') {
    // are there any selected queues?
    if ($('#dcp_selected_processing_queues option').length === 0) {
      modal_notify('Please select at least one queue.', 'danger');
      return false;
    }
  }
  else if (role === 'enhanced_call_processor') {
    // are there any selected call types?
    if ($('#ecp_selected_processing_queues option').length === 0) {
      modal_notify('Please select at least one queue.', 'danger');
      return false;
    }

    // are there any selected call types?
    if ($('#ecp_selected_call_types option').length === 0) {
      modal_notify('Please select at least one call type.', 'danger');
      return false;    
    }
  }
  else if (role === 'outbound_call_processor') {
    var v = $('#ocp_available_industry_types').val().trim()
    if (v === '') {
      modal_notify('Please select an industry type.', 'danger');
      return false;
    }

    // are there any selected call types?
    if ($('#ocp_selected_industries option').length === 0) {
      modal_notify('Please select at least one industry.', 'danger');
      return false;    
    }
  }
  
  return is_valid;
}

}();
